import { FC, ReactNode } from "react";
import "./style.scss";

interface TablePropType {
  children: ReactNode;
}

const Table: FC<TablePropType> = ({ children }) => {
  return (
    <div className="table-component-wrapper">
      <table>{children}</table>
    </div>
  );
};

export default Table;
